import { api } from './client';

export interface ChangeEntry {
  kind: 'audit' | 'handling';
  id: number;
  vehicle_id: number;
  changed_by: string;
  occurred_at: string;
  changes: string | null;
  note: string | null;
  change_note: string | null;
}

export interface VehicleChanges {
  vehicle_id: number;
  name: string | null;
  spawncode: string;
  vehicle_class: string;
  image_url: string | null;
  image_key: string | null;
  latest_change_at: string;
  entries: ChangeEntry[];
}

export const changesApi = {
  list: (days = 30) =>
    api.get<{ vehicles: VehicleChanges[]; days: number }>(`/changes?days=${days}`),
};
